import { LinearGradient } from 'expo-linear-gradient';
import { useEffect, type FC, type ReactNode } from 'react';
import type { ViewStyle } from 'react-native';
import { StyleSheet } from 'react-native';
import { KeyboardStickyView } from 'react-native-keyboard-controller';
import Animated, {
  LinearTransition,
  useAnimatedStyle
} from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';
import { useExtendedKeyboardAnimation } from '@/shared/hooks/useExtendedKeyboardAnimation';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

const styles = StyleSheet.create({
  container: { flex: 1 },
  messages: { flex: 1 }
});

type Props = {
  header: ReactNode;
  messages: ReactNode;
  editor: ReactNode;
  deleted?: boolean;
};

export const ChatLayout: FC<Props> = ({
  header,
  messages,
  editor,
  deleted
}) => {
  const theme = useAppTheme();
  const navigation = useAppNavigation();

  useEffect(() => {
    navigation.setOptions({ header: () => header });
  }, [navigation, header]);

  const { height } = useExtendedKeyboardAnimation();
  const { bottom } = useSafeAreaInsets();

  const animatedStyle = useAnimatedStyle<ViewStyle>(() => ({
    paddingBottom: deleted ? height.value : Math.max(height.value, bottom)
  }));

  const offset = { closed: -bottom, opened: 0 };

  return (
    <>
      <Animated.View
        style={[styles.container, animatedStyle]}
        layout={LinearTransition}
      >
        <LinearGradient
          style={styles.messages}
          colors={[
            theme.colors.surfaceContainer,
            theme.colors.secondaryContainer,
            theme.colors.secondaryContainer
          ]}
        >
          {messages}
        </LinearGradient>
      </Animated.View>
      <KeyboardStickyView offset={offset}>{editor}</KeyboardStickyView>
    </>
  );
};
